import { render } from "./doctorsidebar2.vue?vue&type=template&id=1a01f4f4"
import script from "./doctorsidebar2.vue?vue&type=script&lang=js"
export * from "./doctorsidebar2.vue?vue&type=script&lang=js"

import "./doctorsidebar2.vue?vue&type=style&index=0&id=1a01f4f4&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__